import { IconButton } from "../components/Button";
import { MoonIcon, SunIcon, SystemThemeIcon } from "../components/icons";
import { nl } from "../i18n/nl";
import { nextTheme } from "../theme/theme";
import type { ThemePreference } from "../theme/theme";
import { useTheme } from "../theme/ThemeProvider";

const LABELS: Record<ThemePreference, string> = {
  system: nl.theme.system,
  light: nl.theme.light,
  dark: nl.theme.dark,
};

const ICONS: Record<ThemePreference, typeof SunIcon> = {
  system: SystemThemeIcon,
  light: SunIcon,
  dark: MoonIcon,
};

/** Cycles system → light → dark. */
export function ThemeToggle() {
  const { preference, setPreference } = useTheme();
  const next = nextTheme(preference);
  const Icon = ICONS[preference];
  return (
    <IconButton
      label={nl.theme.toggle(LABELS[preference], LABELS[next])}
      icon={<Icon />}
      onClick={() => {
        setPreference(next);
      }}
    />
  );
}
